/**
 * @description Enum which include all partners.
 */
export enum Partner {
    BANKI_RU = 'Banki-ru',
}
